import React from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { StatCard } from '../../components/ui/StatCard';
import { Select } from '../../components/ui/Select';
import { Button } from '../../components/ui/Button';
import { BarChart3, TrendingUp, Users, Eye, MessageCircle, Heart, Share2, Download, Calendar, Filter } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, PieChart, Pie, Cell } from 'recharts';
// Mock Data
const engagementData = [{
  date: '1 Feb',
  likes: 1200,
  comments: 450,
  views: 5000
}, {
  date: '2 Feb',
  likes: 1500,
  comments: 520,
  views: 6200
}, {
  date: '3 Feb',
  likes: 1100,
  comments: 300,
  views: 4800
}, {
  date: '4 Feb',
  likes: 2200,
  comments: 800,
  views: 9500
}, {
  date: '5 Feb',
  likes: 2800,
  comments: 950,
  views: 12000
}, {
  date: '6 Feb',
  likes: 2400,
  comments: 700,
  views: 10500
}, {
  date: '7 Feb',
  likes: 3100,
  comments: 1100,
  views: 15000
}];
const platformData = [{
  name: 'Instagram',
  value: 45000,
  color: '#ec4899'
}, {
  name: 'TikTok',
  value: 32000,
  color: '#000000'
}, {
  name: 'Facebook',
  value: 15000,
  color: '#3b82f6'
}, {
  name: 'YouTube',
  value: 8000,
  color: '#ef4444'
}, {
  name: 'X',
  value: 5000,
  color: '#0ea5e9'
}];
const sentimentData = [{
  name: 'Positif',
  value: 65,
  color: '#22c55e'
}, {
  name: 'Netral',
  value: 25,
  color: '#94a3b8'
}, {
  name: 'Negatif',
  value: 10,
  color: '#ef4444'
}];
export function DashboardSosmedPage() {
  return <CommandCenterLayout title="Dashboard Media Sosial" subtitle="Analitik performa konten kampanye di seluruh platform" data-id="element-1034">
      <div className="space-y-6" data-id="element-1035">
        {/* Filters */}
        <div className="flex flex-col md:flex-row gap-4 justify-between items-center bg-white p-4 rounded-lg border shadow-sm" data-id="element-1036">
          <div className="flex flex-wrap gap-4 w-full md:w-auto" data-id="element-1037">
            <div className="w-full md:w-48" data-id="element-1038">
              <label className="text-xs font-medium text-gray-500 mb-1 block" data-id="element-1039">
                Campaign
              </label>
              <Select data-id="element-1040">
                <option data-id="element-1041">Semua Campaign</option>
                <option data-id="element-1042">HPSN 2025</option>
                <option data-id="element-1043">Bank Sampah</option>
              </Select>
            </div>
            <div className="w-full md:w-48" data-id="element-1044">
              <label className="text-xs font-medium text-gray-500 mb-1 block" data-id="element-1045">
                Periode
              </label>
              <Select data-id="element-1046">
                <option data-id="element-1047">7 Hari Terakhir</option>
                <option data-id="element-1048">30 Hari Terakhir</option>
                <option data-id="element-1049">Bulan Ini</option>
                <option data-id="element-1050">Tahun Ini</option>
              </Select>
            </div>
            <div className="w-full md:w-48" data-id="element-1051">
              <label className="text-xs font-medium text-gray-500 mb-1 block" data-id="element-1052">
                Wilayah
              </label>
              <Select data-id="element-1053">
                <option data-id="element-1054">Semua Wilayah</option>
                <option data-id="element-1055">Jawa</option>
                <option data-id="element-1056">Sumatera</option>
              </Select>
            </div>
          </div>
          <Button variant="outline" className="gap-2" data-id="element-1057">
            <Download className="h-4 w-4" data-id="element-1058" /> Export Report
          </Button>
        </div>

        {/* Key Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1059">
          <StatCard title="Total Views" value="1.2M" icon={Eye} trend={{
          value: '+12%',
          direction: 'up'
        }} description="Impressions across all platforms" data-id="element-1060" />
          <StatCard title="Total Likes" value="85.4K" icon={Heart} trend={{
          value: '+5.2%',
          direction: 'up'
        }} data-id="element-1061" />
          <StatCard title="Comments" value="12.8K" icon={MessageCircle} trend={{
          value: '+8.1%',
          direction: 'up'
        }} data-id="element-1062" />
          <StatCard title="Shares" value="4.2K" icon={Share2} trend={{
          value: '-2.5%',
          direction: 'down'
        }} data-id="element-1063" />
        </div>

        {/* Charts Row 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1064">
          <Card className="lg:col-span-2" data-id="element-1065">
            <CardHeader data-id="element-1066">
              <CardTitle data-id="element-1067">Tren Engagement Harian</CardTitle>
            </CardHeader>
            <CardContent data-id="element-1068">
              <div className="h-[300px]" data-id="element-1069">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1070">
                  <LineChart data={engagementData} data-id="element-1071">
                    <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-1072" />
                    <XAxis dataKey="date" axisLine={false} tickLine={false} data-id="element-1073" />
                    <YAxis axisLine={false} tickLine={false} data-id="element-1074" />
                    <Tooltip data-id="element-1075" />
                    <Legend data-id="element-1076" />
                    <Line type="monotone" dataKey="views" stroke="#6366f1" strokeWidth={2} dot={false} name="Views" data-id="element-1077" />
                    <Line type="monotone" dataKey="likes" stroke="#ec4899" strokeWidth={2} dot={false} name="Likes" data-id="element-1078" />
                    <Line type="monotone" dataKey="comments" stroke="#10b981" strokeWidth={2} dot={false} name="Comments" data-id="element-1079" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-1080">
            <CardHeader data-id="element-1081">
              <CardTitle data-id="element-1082">Share of Voice (Platform)</CardTitle>
            </CardHeader>
            <CardContent data-id="element-1083">
              <div className="h-[300px]" data-id="element-1084">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1085">
                  <PieChart data-id="element-1086">
                    <Pie data={platformData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-1087">
                      {platformData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1088" />)}
                    </Pie>
                    <Tooltip data-id="element-1089" />
                    <Legend data-id="element-1090" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Charts Row 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1091">
          <Card data-id="element-1092">
            <CardHeader data-id="element-1093">
              <CardTitle data-id="element-1094">Performa per Platform</CardTitle>
            </CardHeader>
            <CardContent data-id="element-1095">
              <div className="h-[300px]" data-id="element-1096">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1097">
                  <BarChart data={platformData} layout="vertical" data-id="element-1098">
                    <CartesianGrid strokeDasharray="3 3" horizontal={false} data-id="element-1099" />
                    <XAxis type="number" hide data-id="element-1100" />
                    <YAxis dataKey="name" type="category" width={80} axisLine={false} tickLine={false} data-id="element-1101" />
                    <Tooltip data-id="element-1102" />
                    <Bar dataKey="value" fill="#3b82f6" radius={[0, 4, 4, 0]} barSize={30} data-id="element-1103">
                      {platformData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1104" />)}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-1105">
            <CardHeader data-id="element-1106">
              <CardTitle data-id="element-1107">Analisis Sentimen Komentar</CardTitle>
            </CardHeader>
            <CardContent data-id="element-1108">
              <div className="h-[300px] flex items-center justify-center" data-id="element-1109">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1110">
                  <PieChart data-id="element-1111">
                    <Pie data={sentimentData} cx="50%" cy="50%" outerRadius={100} dataKey="value" label={({
                    name,
                    percent
                  }) => `${name} ${(percent * 100).toFixed(0)}%`} data-id="element-1112">
                      {sentimentData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1113" />)}
                    </Pie>
                    <Tooltip data-id="element-1114" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Top Performers Table */}
        <Card data-id="element-1115">
          <CardHeader data-id="element-1116">
            <CardTitle data-id="element-1117">Top Performing Regions</CardTitle>
          </CardHeader>
          <CardContent data-id="element-1118">
            <div className="overflow-x-auto" data-id="element-1119">
              <table className="w-full text-sm text-left" data-id="element-1120">
                <thead className="bg-gray-50 border-b" data-id="element-1121">
                  <tr data-id="element-1122">
                    <th className="px-4 py-3" data-id="element-1123">Rank</th>
                    <th className="px-4 py-3" data-id="element-1124">Daerah</th>
                    <th className="px-4 py-3" data-id="element-1125">Total Posts</th>
                    <th className="px-4 py-3" data-id="element-1126">Total Engagement</th>
                    <th className="px-4 py-3" data-id="element-1127">Avg. Views/Post</th>
                    <th className="px-4 py-3" data-id="element-1128">Viral Score</th>
                  </tr>
                </thead>
                <tbody className="divide-y" data-id="element-1129">
                  {[1, 2, 3, 4, 5].map(rank => <tr key={rank} className="hover:bg-gray-50" data-id="element-1130">
                      <td className="px-4 py-3 font-bold text-gray-500" data-id="element-1131">
                        #{rank}
                      </td>
                      <td className="px-4 py-3 font-medium" data-id="element-1132">
                        {rank === 1 ? 'Kota Surabaya' : rank === 2 ? 'DKI Jakarta' : rank === 3 ? 'Kota Bandung' : rank === 4 ? 'Kota Medan' : 'Kota Makassar'}
                      </td>
                      <td className="px-4 py-3" data-id="element-1133">45</td>
                      <td className="px-4 py-3" data-id="element-1134">125,000</td>
                      <td className="px-4 py-3" data-id="element-1135">2,700</td>
                      <td className="px-4 py-3" data-id="element-1136">
                        <div className="w-16 bg-gray-100 rounded-full h-1.5" data-id="element-1137">
                          <div className="bg-purple-500 h-1.5 rounded-full" style={{
                        width: `${90 - rank * 10}%`
                      }} data-id="element-1138"></div>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      </div>
    </CommandCenterLayout>;
}